import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input } from '@angular/core'

@Component({
    selector: 'ca-contract-list-item-owners',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <span class="addedTooltip" title="{{subjects | displayMultipleNames}}">
            <span class="initialFont">{{subjects | displayCountOwners}}</span>
            <ca-subject-user-badge [subjects]="subjects"></ca-subject-user-badge>
            <span class="secondLine">({{subjects | displayMultipleNamesShort:70}})</span>
        </span>
    `,
    standalone: false
})
export class ContractListItemOwnersComponent {
    @Input() subjects: any

    constructor(@Inject(ChangeDetectorRef) private changeDetector) {
        this.changeDetector.markForCheck()
    }
}
